<div class="card-container">
  <h1 class="default-title-3">{{ title }}</h1>
  <p class="card-text">{{ text }}</p>
  <app-button label="Simular" color="secondary" [linkTo]="linkTo"></app-button>
</div>
